import React from 'react'
import { Box, Container } from 'pcln-design-system'
import ScrollableDealModule from '@/components/ScrollableDealModule'
import useFetchPackages, {
  PACKAGE_DISPLAY_MINIMUM
} from '@/hooks/useFetchPackages'
import useGeoPosition from '@/hooks/useGeoPosition'
import DealCarouselLoader from '@/components/DealCarouselLoader'

const PackagesCarousel = ({
  heading = "Don't miss these package deals",
  headingMobile = "Don't miss these deals"
}) => {
  const { longitude, latitude } = useGeoPosition()
  const { deals, didFetchSucceed } = useFetchPackages({ latitude, longitude })
  return didFetchSucceed ? (
    <Box>
      <Container maxWidth={1280}>
        <Box px={3} mt={4}>
          {deals.length >= PACKAGE_DISPLAY_MINIMUM ? (
            <ScrollableDealModule
              content={{
                heading,
                headingMobile,
                dataArray: deals
              }}
              handleNavOnClick={(href: string) => window.open(href)}
            />
          ) : (
            <DealCarouselLoader />
          )}
        </Box>
      </Container>
    </Box>
  ) : null
}

export default PackagesCarousel
